import Siprec, { request, fetch, ROOT_URL } from './factory/Siprec'
import Locale from '@/locale'

let model = Siprec({
  name: 'users',
  enums: {
    role: {
      SUPER_ADMIN: Locale.t('userRole.superAdmin'),
      GROUP_ADMIN: Locale.t('userRole.groupAdmin'),
      COMPANY_ADMIN: Locale.t('userRole.companyAdmin'),
      COMPANY_USER: Locale.t('userRole.companyUser')
    }
  },
  methods: {
    getSelf (username) {
      if (!username) {
        throw new Error('Username is empty')
      }

      return fetch(`users?username=[EQ]${username}`, 'users', {
        include: [['company', 'companyGroup', 'configuration'], ['companyGroups', 'companies'], 'userCertificates']
      }).then(result => {
        if (result.items.length === 0) {
          this.error = this.$t('login.unknownError')
          this.isBusy = false
          return Promise.reject('Failed to load user details. Empty response.')
        }

        return result.items[0]
      })
    },

    setPassword (data) {
      let url = data._self || `${ROOT_URL}/users`
      return request(
        {
          method: 'PUT',
          url: `${url}/changepwd`,
          data: {
            password: data.password
          }
        })
        .then(result => result.data)
    },

    resetPassword (token, password) {
      let url = `${ROOT_URL}/users/resetpwd`
      return request(
        {
          method: 'PUT',
          url,
          data: {
            password,
            token
          }
        })
    },

    requestReset (username) {
      username = encodeURIComponent(username)
      let url = `${ROOT_URL}/users/requestresetpwd/${username}`
      return request({
        method: 'GET',
        url
      })
    },

    sendInfo (data) {
      let url = `${ROOT_URL}/users/notifyNewUser/${data.username}`
      return request({
        method: 'POST',
        url,
        data: {
          password: data.password || null
        }
      })
    },

    logout () {
      return request({
        method: 'GET',
        url: `${ROOT_URL}/users/logout`
      })
    },

    getPasswordComplexity (token) {
      let url = `${ROOT_URL}/users/passwordComplexity`
      let options = {
        url
      }
      if (token) {
        options.method = 'POST'
        options.data = {
          token
        }
      } else {
        options.method = 'GET'
      }
      return request(options).then(response => response.data)
    },

    getDelegation (user, options) {
      return fetch(
        `${ROOT_URL}/users/${user.id}/companyDelegation`,
        'companyDelegation',
        options
      )
    }
  }
})

export default model



// WEBPACK FOOTER //
// ./src/models/User.js